<template>
  <div class="hello">
    <div
      class="card"
      :style="{
        'min-height': $store.state.screenHeight - 140 + 'px',
        overflow: 'hidden',
      }"
    >
      <div class="card-body">
        <h5 class="card-title">
          <i class="fas fa-scroll"></i>
          รายงานสรุปยอดคงค้างรายเดือน
        </h5>
        <hr />
        <div
          class="contianer"
          style="height: 100%; overflow-x: hidden; overflow-y: auto;"
        >
          <div class="form-group row">
            <label for="staticEmail" class="col-sm-2 col-form-label text-right">
              เลือกเดือน
            </label>
            <div class="col-sm-4">
              <input
                type="month"
                class="form-control"
                v-model="dateNow"
                @change="getOutstand"
              />
            </div>
            <label for="staticEmail" class="col-sm-1 col-form-label text-right">
              โซน
            </label>
            <div class="col-sm-2">
              <select
                class="form-control"
                id="inputZone"
                v-model="zone"
                @change="getOutstand"
              >
                <option value>-- ทั้งหมด --</option>
                <option
                  :value="zone.zone_id"
                  v-for="(zone, z) in zone_list"
                  :key="'optionzone' + z"
                >
                  {{ zone.zone_name }}
                </option>
              </select>
            </div>
            <form :action="pdf_url" method="post" target="_blank">
              <input type="hidden" v-model="data_outstand" name="data" />
              <input type="hidden" v-model="data_month" name="month" />
              <button
                type="submit"
                class="btn btn-info mr-2"
                :disabled="data_list.length < 1"
              >
                Export PDF
              </button>
            </form>
            <form
              :action="excel_url"
              method="post"
              target="_blank"
            >
              <input type="hidden" v-model="data_outstand" name="data" />
              <input type="hidden" v-model="data_month" name="month" />
              <button
                class="btn btn-success"
                type="submit"
                :disabled="data_list.length < 1"
              >
                Export Excel
              </button>
            </form>
          </div>
          <hr />
          <div class="table-responsive">
            <table class="table">
              <thead class="thead-dark">
                <tr class="text-center">
                  <th scope="col">#</th>
                  <th scope="col" style="width: 10%;">บ้านเลขที่</th>
                  <th scope="col" style="width: 15%;">ชื่อเจ้าบ้าน</th>
                  <th scope="col" style="width: 10%;">โซน</th>
                  <th scope="col" style="width: 5%;">พื้นที่</th>
                  <th scope="col" style="width: 10%;">เดือน</th>
                  <th scope="col" style="width: 12%;">ค่าส่วนกลาง</th>
                  <th scope="col" style="width: 10%;">ค่าน้ำ</th>
                  <th scope="col" style="width: 13%;">ค่าใช้จ่ายอื่น ๆ</th>
                  <th scope="col" style="width: 10%;">ชำระแล้ว</th>
                  <th scope="col" style="width: 10%;">คงค้าง</th>
                </tr>
              </thead>
              <tbody v-for="(h, i) in data_list" :key="'h' + i">
                <tr class="text-center">
                  <td>{{ i + 1 }}</td>
                  <td style="width: 10%;">{{ h.home_number }}</td>
                  <td style="width: 20%;" class="text-left">
                    {{ h.home_fullname }}
                  </td>
                  <td style="width: 5%;">{{ h.zone_name }}</td>
                  <td style="width: 5%;">{{ h.home_area }}</td>
                  <td style="width: 10%;" class="text-center">
                    {{ dateFormatMY(h.date_bill) }}
                  </td>
                  <td style="width: 15%;" class="text-right">
                    {{ numberFormat(h.central_value) }}
                  </td>
                  <td style="width: 10%;" class="text-right">
                    {{ numberFormat(h.water_amount) }}
                  </td>
                  <td style="width: 15%;" class="text-right">
                    {{ numberFormat(h.other_amount) }}
                  </td>
                  <td style="width: 10%;" class="text-right">
                    {{ numberFormat(h.payment_amount) }}
                  </td>
                  <td style="width: 10%;" class="text-right">
                    {{ numberFormat(h.total_amount) }}
                  </td>
                </tr>
                <!-- <tr>
                  <th colspan="8" class="text-left">รวม</th>
                  <th class="text-right">
                    {{ numberFormat(h.invoice_amount - h.invoice_payment) }}
                  </th>
                </tr> -->
              </tbody>
              <tr v-if="data_list.length > 0">
                <th colspan="9" class="text-left">รวมทั้งหมด</th>
                <th class="text-right">{{ numberFormat(sum_paid) }}</th>
                <th class="text-right">{{ numberFormat(sum_amount) }}</th>
              </tr>
              <tr class="text-center" v-if="data_list.length < 1">
                <th colspan="11">ไม่มีข้อมูล</th>
              </tr>
            </table>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
// Keep simple import for outstanding_report
import OutstandingReport from '../assets/js/outstanding_report.js'
import Con from '../../static/config.json'

export default {
  mixins: [OutstandingReport],
  data () {
    const baseUrl = Con.URL
      .replace(/index\.php\/?$/, '')
      .replace(/\/api\/?$/, '/')
    return {
      pdf_url: baseUrl + 'pdf/outstand_pdf.php',
      excel_url: baseUrl + 'excel/outstand_excel.php'
    }
  }
}
</script>

<style>
.table th,
td {
  font-size: 12px;
}
</style>



// WEBPACK FOOTER //
// src/views/outstanding.vue